/**
 * Converts long strings into shorter strings that show the start and end of it, while ensuring that no incomplete tokens are returned, even if that means going above the desired length.
 *
 * @param {String} text     The string to abbreviate
 * @param {Object} options  Options to set things like the length of the short string
 *
 * @return {String} The shorter string
 */
const abbreviateText = ( text = '', options = { words: 6 } ) => {
	// Check if the text is really text (string)
	if ( typeof text !== 'string' ) {
		return text;
	}

	try {
		// Get the words of the string
		const words = text.split( /\s+(?![^\{\{]*\}\})/ );

		if ( words.length <= options.words ) {
			return text;
		}

		// Number of words per part
		const wordsPerPart = Math.floor( options.words / 2 );

		// Return the abbreviated text
		return `${ words.slice( 0, wordsPerPart ).join( ' ' ) } ... ${ words.slice( -wordsPerPart ).join( ' ' ) }`;
	} catch ( e ) {
		// Check if debugging mode is enabled
		// eslint-disable-next-line no-lonely-if
		if ( UncannyAutomator._site.has_debug_enabled ) {
			// eslint-disable-next-line no-console
			console.warn( e );
		}

		return text;
	}
}

export default abbreviateText;
